export const ROLES = {
  ADMIN_CST: 130,
  ADMIN_MP: 131,
  SUPPORT: 120,
  USER: 110,
  // SINGLEPLATFORM: 111,
  // CONSTANTCONTACT: 112,
  HOSTGATOR: 115,
  FINANCIAL: 139,
  STORE: 140,
  ANALYTICS: 150,
  TRANSLATIONS: 160,
  DEV_ADMIN: 170,
  BETA: 180,
  // SALES_AGENT: 190,
  // SALES_MANAGER: 191,
  ESCALATED_SUPPORT: 121,
  SUPPORT_MANAGER: 122,
  FAAS: 200,
  CREATIVE_EMAIL: 210,
  BRAND_SITELIO: 1002,
  BRAND_WEBSITEBUILDER: 1003,
  BRAND_SITEY: 1005,
  BRAND_SITEBUILDER: 1006,
  BRAND_GATOR: 1040,
  BRAND_CONSTANTCONTACT: 1050,
  BRAND_CREATIVE_MAIL: 1060,
  BRAND_HOSTING: 1100,
  BRAND_BLUEHOST: 1101,
  BRAND_DOMAINCOM: 1108,
  BRAND_SINGLEPLATFORM: 2003
}

export const ROLE_NAMES = {
  [ROLES.ADMIN_CST]: 'Admin CST',
  [ROLES.ADMIN_MP]: 'Admin MP',
  [ROLES.SUPPORT]: 'Support',
  [ROLES.ESCALATED_SUPPORT]: 'Escalated Support',
  [ROLES.SUPPORT_MANAGER]: 'Support Manager',
  [ROLES.USER]: 'User',
  [ROLES.HOSTGATOR]: 'HostGator',
  [ROLES.FINANCIAL]: 'Financial',
  [ROLES.STORE]: 'Store',
  [ROLES.ANALYTICS]: 'Analytics',
  [ROLES.TRANSLATIONS]: 'Translations',
  [ROLES.DEV_ADMIN]: 'Dev Admin',
  [ROLES.BETA]: 'Beta',
  [ROLES.SALES_AGENT]: 'Sales Agent',
  [ROLES.SALES_MANAGER]: 'Sales Manager',
  [ROLES.FAAS]: 'FaaS',
  [ROLES.CREATIVE_EMAIL]: 'Creative Email',
  [ROLES.BRAND_SITELIO]: 'Sitelio',
  [ROLES.BRAND_WEBSITEBUILDER]: 'WebsiteBuilder',
  [ROLES.BRAND_SITEY]: 'Sitey',
  [ROLES.BRAND_SITEBUILDER]: 'SiteBuilder',
  [ROLES.BRAND_GATOR]: 'Gator',
  [ROLES.BRAND_CONSTANTCONTACT]: 'Constant Contact',
  [ROLES.BRAND_SINGLEPLATFORM]: 'SP Managed WS',
  [ROLES.BRAND_HOSTING]: 'Hosting Brands',
  [ROLES.BRAND_CREATIVE_MAIL]: 'Creative Mail',
  [ROLES.BRAND_BLUEHOST]: 'Bluehost',
  [ROLES.BRAND_DOMAINCOM]: 'Domain.com'
}

export const MP_ROLES = {
  ADMIN_MP: ROLES.ADMIN_MP,
  FINANCIAL: ROLES.FINANCIAL,
  ANALYTICS: ROLES.ANALYTICS,
  STORE: ROLES.STORE,
  TRANSLATIONS: ROLES.TRANSLATIONS,
  DEV_ADMIN: ROLES.DEV_ADMIN
}

export const CST_ROLES = {
  ADMIN_CST: ROLES.ADMIN_CST,
  SUPPORT: ROLES.SUPPORT,
  USER: ROLES.USER,
  // SINGLEPLATFORM: ROLES.SINGLEPLATFORM,
  // CONSTANTCONTACT: ROLES.CONSTANTCONTACT,
  HOSTGATOR: ROLES.HOSTGATOR
}

export const SUPPORT_MANAGER_ROLES = {
  SUPPORT: ROLES.SUPPORT
}

export const PAGES = {
  CUSTOMERS: 'CUSTOMERS',
  ORDER_FOLLOWUPS: 'ORDER_FOLLOWUPS',
  DOMAINS: 'DOMAINS',
  PAYPAL: 'PAYPAL',
  COMPLIANCE: 'COMPLIANCE',
  ROLE_MANAGEMENT: 'ROLE_MANAGEMENT',
  NEW_ACCOUNT: 'NEW_ACCOUNT',
  COMMENTS: 'COMMENTS',
  DEVELOPMENT: 'DEVELOPMENT',
  TESTING_TOOLS: 'TESTING_TOOLS',
  REPORTS: 'REPORTS',
  REPORTS_WORDPRESS_CM: 'REPORTS_WORDPRESS_CM',
  REPORTS_WORDPRESS_EDITOR: 'REPORTS_WORDPRESS_EDITOR',
  REPORTS_BUILDER: 'REPORTS_BUILDER',
  REPORTS_GATOR: 'REPORTS_GATOR',
  REPORTS_CTCT: 'REPORTS_CTCT',
  REPORTS_EMAIL_MARKETING: 'REPORTS_EMAIL_MARKETING',
  REPORTS_STORE: 'REPORTS_STORE',
  REPORTS_SOCIAL: 'REPORTS_SOCIAL',
  REPORTS_SITE: 'REPORTS_SITE',
  REPORTS_ADVANCED: 'REPORTS_ADVANCED',
  CONFIGURATION: 'CONFIGURATION',
  SUSPICIOUS_MANAGEMENT: 'SUSPICIOUS_MANAGEMENT',
  TOPICS: 'TOPICS',
  TRANSLATIONS: 'TRANSLATIONS',
  TRANSLATIONS_CONFIGURATION: 'TRANSLATIONS_CONFIGURATION',
  AGENT_SALES: 'AGENT_SALES',
  RELEASE_NOTES: 'RELEASE_NOTES',
  IN_PRODUCT_MESSAGING: 'IN_PRODUCT_MESSAGING',
  CHUNKS: 'CHUNKS',
  SIFT_REPORT_TOOL: 'SIFT_REPORT_TOOL',
  PAAS_RECYCLE_QUEUE: 'PAAS_RECYCLE_QUEUE',
  COUPON_CODES: 'COUPON_CODES',
  WELCOME_EMAILS: 'WELCOME_EMAILS',
  CREATE_TEST_ACCOUNT: 'CREATE_TEST_ACCOUNT'
}

export const ROLE_PAGE_ACCESS = {
  [ROLES.ADMIN_CST]: [
    PAGES.CUSTOMERS,
    PAGES.ORDER_FOLLOWUPS,
    PAGES.DOMAINS,
    PAGES.PAYPAL,
    PAGES.COMPLIANCE,
    PAGES.ROLE_MANAGEMENT,
    PAGES.NEW_ACCOUNT,
    PAGES.COMMENTS,
    PAGES.CONFIGURATION,
    PAGES.SUSPICIOUS_MANAGEMENT,
    PAGES.TOPICS,
    PAGES.TRANSLATIONS,
    PAGES.IN_PRODUCT_MESSAGING,
    PAGES.CHUNKS,
    PAGES.FEATURE_FLAG,
    PAGES.COUPON_CODES,
    PAGES.REPORTS,
    PAGES.SIFT_REPORT_TOOL,
    PAGES.PAAS_RECYCLE_QUEUE,
    PAGES.COUPON_CODES,
    PAGES.WELCOME_EMAILS,
    PAGES.TESTING_TOOLS,
    PAGES.CREATE_TEST_ACCOUNT,
    PAGES.REPORTS_BUILDER,
    PAGES.REPORTS_GATOR,
    PAGES.REPORTS_CTCT,
    PAGES.REPORTS_EMAIL_MARKETING,
    PAGES.REPORTS_STORE,
    PAGES.REPORTS_SOCIAL,
    PAGES.REPORTS_SITE,
    PAGES.REPORTS_ADVANCED,
    PAGES.REPORTS_WORDPRESS_CM,
    PAGES.REPORTS_WORDPRESS_EDITOR
  ],
  [ROLES.ADMIN_MP]: [
    PAGES.CUSTOMERS,
    PAGES.ORDER_FOLLOWUPS,
    PAGES.DOMAINS,
    PAGES.PAYPAL,
    PAGES.COMPLIANCE,
    PAGES.COMMENTS,
    PAGES.ROLE_MANAGEMENT,
    PAGES.NEW_ACCOUNT,
    PAGES.IN_PRODUCT_MESSAGING,
    PAGES.CHUNKS,
    PAGES.FEATURE_FLAG,
    PAGES.COUPON_CODES,
    PAGES.REPORTS,
    PAGES.REPORTS_BUILDER,
    PAGES.REPORTS_GATOR,
    PAGES.REPORTS_CTCT,
    PAGES.REPORTS_EMAIL_MARKETING,
    PAGES.REPORTS_STORE,
    PAGES.REPORTS_SOCIAL,
    PAGES.REPORTS_SITE,
    PAGES.REPORTS_ADVANCED,
    PAGES.CONFIGURATION,
    PAGES.TOPICS,
    PAGES.TRANSLATIONS,
    PAGES.TRANSLATIONS_CONFIGURATION,
    PAGES.REPORTS_WORDPRESS_CM,
    PAGES.REPORTS_WORDPRESS_EDITOR
  ],
  [ROLES.SUPPORT]: [
    PAGES.CUSTOMERS,
    PAGES.PAYPAL
  ],
  [ROLES.USER]: [PAGES.CUSTOMERS, PAGES.DEVELOPMENT, PAGES.TESTING_TOOLS],
  // [ROLES.SINGLEPLATFORM]: [PAGES.CUSTOMERS, PAGES.NEW_ACCOUNT],
  // [ROLES.CONSTANTCONTACT]: [PAGES.CUSTOMERS, PAGES.NEW_ACCOUNT],
  [ROLES.HOSTGATOR]: [PAGES.CUSTOMERS],
  [ROLES.FINANCIAL]: [PAGES.REPORTS, PAGES.REPORTS_BUILDER, PAGES.REPORTS_GATOR, PAGES.REPORTS_CTCT],
  [ROLES.STORE]: [PAGES.REPORTS, PAGES.REPORTS_STORE],
  [ROLES.ANALYTICS]: [
    PAGES.COMMENTS,
    PAGES.REPORTS,
    PAGES.REPORTS_SITE,
    PAGES.REPORTS_ADVANCED,
    PAGES.REPORTS_SOCIAL,
    PAGES.REPORTS_EMAIL_MARKETING,
    PAGES.REPORTS_WORDPRESS_CM,
    PAGES.REPORTS_WORDPRESS_EDITOR
  ],
  [ROLES.TRANSLATIONS]: [PAGES.CONFIGURATION, PAGES.TRANSLATIONS],
  [ROLES.DEV_ADMIN]: [
    PAGES.DEVELOPMENT,
    PAGES.TESTING_TOOLS,
    PAGES.CONFIGURATION,
    PAGES.SUSPICIOUS_MANAGEMENT,
    PAGES.TOPICS,
    PAGES.TRANSLATIONS_CONFIGURATION,
    PAGES.REPORTS,
    PAGES.SIFT_REPORT_TOOL,
    PAGES.CHUNKS,
    PAGES.FEATURE_FLAG,
    PAGES.COUPON_CODES,
    PAGES.CREATE_TEST_ACCOUNT
  ],
  [ROLES.BETA]: [
    PAGES.CONFIGURATION,
    PAGES.TOPICS,
    PAGES.TRANSLATIONS,
    PAGES.TRANSLATIONS_CONFIGURATION,
    PAGES.REPORTS_EMAIL_MARKETING
  ],
  [ROLES.SALES_AGENT]: [PAGES.CUSTOMERS, PAGES.AGENT_SALES],
  [ROLES.SALES_MANAGER]: [PAGES.CUSTOMERS, PAGES.AGENT_SALES],
  [ROLES.FAAS]: [PAGES.SIFT_REPORT_TOOL],
  [ROLES.CREATIVE_EMAIL]: [PAGES.REPORTS, PAGES.REPORTS_EMAIL_MARKETING],
  [ROLES.ESCALATED_SUPPORT]: [
    PAGES.CUSTOMERS,
    PAGES.ORDER_FOLLOWUPS,
    PAGES.DOMAINS,
    PAGES.PAYPAL,
    PAGES.COMPLIANCE,
    PAGES.COMMENTS,
    PAGES.CONFIGURATION,
    PAGES.SUSPICIOUS_MANAGEMENT,
    PAGES.CHUNKS,
    PAGES.COUPON_CODES
  ],
  [ROLES.SUPPORT_MANAGER]: [
    PAGES.CUSTOMERS,
    PAGES.ORDER_FOLLOWUPS,
    PAGES.DOMAINS,
    PAGES.PAYPAL,
    PAGES.COMPLIANCE,
    PAGES.COMMENTS,
    PAGES.ROLE_MANAGEMENT,
    PAGES.NEW_ACCOUNT,
    PAGES.CONFIGURATION,
    PAGES.CHUNKS,
    PAGES.COUPON_CODES,
    PAGES.SUSPICIOUS_MANAGEMENT,
    PAGES.TOPICS
  ]
}

export const ROLE_FEATURES = {
  CUSTOMER: 'CUSTOMER',
  ORDER_FOLLOWUPS: 'ORDER_FOLLOWUPS',
  DOMAINS: 'DOMAINS',
  PAYPAL: 'PAYPAL',
  COMPLIANCE: 'COMPLIANCE',
  ROLE_MANAGEMENT: 'ROLE_MANAGEMENT',
  CUSTOMER_VALIDATION: 'CUSTOMER_VALIDATION',
  NEW_SP_ACCOUNT: 'NEW_SP_ACCOUNT',
  NEW_CTCT_ACCOUNT: 'NEW_CTCT_ACCOUNT',
  REPORTS_FINANCIAL: 'REPORTS_FINANCIAL',
  REPORTS_NON_FINANCIAL: 'REPORTS_NON_FINANCIAL',
  CONFIG_TRANSLATIONS: 'CONFIG_TRANSLATIONS',
  CONFIG_DEVELOPER_TOOLS: 'CONFIG_DEVELOPER_TOOLS',
  ACCOUNT_DETAILS: 'ACCOUNT_DETAILS',
  COPY_SITE: 'COPY_SITE',
  CANCEL_ACCOUNT: 'CANCEL_ACCOUNT',
  ACCOUNT_LOGIN: 'ACCOUNT_LOGIN',
  REMOVE_FREE_DOMAIN_CREDIT: 'REMOVE_FREE_DOMAIN_CREDIT',
  VIEW_OWN_AGENT_SALES: 'VIEW_OWN_SALES',
  VIEW_ALL_AGENT_SALES: 'VIEW_ALL_AGENT_SALES',
  RELEASE_NOTES: 'RELEASE_NOTES',
  IN_PRODUCT_MESSAGING: 'IN_PRODUCT_MESSAGING',
  EDIT_CHUNKS: 'EDIT_CHUNKS',
  VIEW_ACCOUNT_BUTTON: 'VIEW_ACCOUNT_BUTTON',
  ADD_EDIT_COUPONS: 'ADD_EDIT_COUPONS',
  ACCOUNT_RELINK: 'ACCOUNT_RELINK',
  RESTORE_SERVICES: 'RESTORE_SERVICES',
  GSUITE_EMAIL_FIX: 'GSUITE_EMAIL_FIX'
}

export const CST_MP_ROLE_MATRIX = {
  [ROLES.ADMIN_CST]: [
    ROLE_FEATURES.CUSTOMER,
    ROLE_FEATURES.ACCOUNT_DETAILS,
    ROLE_FEATURES.COPY_SITE,
    ROLE_FEATURES.CANCEL_ACCOUNT,
    ROLE_FEATURES.ORDER_FOLLOWUPS,
    ROLE_FEATURES.DOMAINS,
    ROLE_FEATURES.PAYPAL,
    ROLE_FEATURES.COMPLIANCE,
    ROLE_FEATURES.ROLE_MANAGEMENT,
    ROLE_FEATURES.CUSTOMER_VALIDATION,
    ROLE_FEATURES.ACCOUNT_LOGIN,
    ROLE_FEATURES.REMOVE_FREE_DOMAIN_CREDIT,
    ROLE_FEATURES.VIEW_ALL_AGENT_SALES,
    ROLE_FEATURES.IN_PRODUCT_MESSAGING,
    ROLE_FEATURES.VIEW_ACCOUNT_BUTTON,
    ROLE_FEATURES.ACCOUNT_RELINK,
    ROLE_FEATURES.RESTORE_SERVICES,
    ROLE_FEATURES.ADD_EDIT_COUPONS,
    ROLE_FEATURES.GSUITE_EMAIL_FIX
  ],
  [ROLES.ADMIN_MP]: [
    ROLE_FEATURES.CUSTOMER,
    ROLE_FEATURES.ACCOUNT_DETAILS,
    ROLE_FEATURES.COPY_SITE,
    ROLE_FEATURES.CANCEL_ACCOUNT,
    ROLE_FEATURES.ORDER_FOLLOWUPS,
    ROLE_FEATURES.DOMAINS,
    ROLE_FEATURES.PAYPAL,
    ROLE_FEATURES.COMPLIANCE,
    ROLE_FEATURES.ROLE_MANAGEMENT,
    ROLE_FEATURES.REPORTS_FINANCIAL,
    ROLE_FEATURES.REPORTS_NON_FINANCIAL,
    ROLE_FEATURES.CONFIG_TRANSLATIONS,
    ROLE_FEATURES.CONFIG_DEVELOPER_TOOLS,
    ROLE_FEATURES.ACCOUNT_LOGIN,
    ROLE_FEATURES.VIEW_ACCOUNT_BUTTON,
    ROLE_FEATURES.CUSTOMER_VALIDATION,
    ROLE_FEATURES.REMOVE_FREE_DOMAIN_CREDIT,
    ROLE_FEATURES.ADD_EDIT_COUPONS,
    ROLE_FEATURES.GSUITE_EMAIL_FIX
  ],
  [ROLES.SUPPORT]: [
    ROLE_FEATURES.CUSTOMER,
    ROLE_FEATURES.ACCOUNT_DETAILS,
    ROLE_FEATURES.ACCOUNT_LOGIN,
    ROLE_FEATURES.VIEW_ACCOUNT_BUTTON,
    ROLE_FEATURES.REMOVE_FREE_DOMAIN_CREDIT,
    ROLE_FEATURES.GSUITE_EMAIL_FIX
  ],
  [ROLES.USER]: [ROLE_FEATURES.CUSTOMER, ROLE_FEATURES.CONFIG_TRANSLATIONS, ROLE_FEATURES.ACCOUNT_LOGIN],
  [ROLES.SINGLEPLATFORM]: [
    ROLE_FEATURES.CUSTOMER,
    ROLE_FEATURES.NEW_SP_ACCOUNT,
    ROLE_FEATURES.ACCOUNT_LOGIN,
    ROLE_FEATURES.VIEW_ACCOUNT_BUTTON
  ],
  [ROLES.CONSTANTCONTACT]: [ROLE_FEATURES.CUSTOMER, ROLE_FEATURES.NEW_CTCT_ACCOUNT, ROLE_FEATURES.ACCOUNT_LOGIN],
  [ROLES.HOSTGATOR]: [ROLE_FEATURES.CUSTOMER, ROLE_FEATURES.VIEW_ACCOUNT_BUTTON],
  [ROLES.FINANCIAL]: [ROLE_FEATURES.REPORTS_FINANCIAL],
  [ROLES.ANALYTICS]: [ROLE_FEATURES.REPORTS_NON_FINANCIAL],
  [ROLES.TRANSLATIONS]: [ROLE_FEATURES.CONFIG_TRANSLATIONS],
  [ROLES.DEV_ADMIN]: [
    ROLE_FEATURES.CONFIG_DEVELOPER_TOOLS,
    ROLE_FEATURES.EDIT_CHUNKS,
    ROLE_FEATURES.ADD_EDIT_COUPONS,
    ROLE_FEATURES.ACCOUNT_RELINK,
    ROLE_FEATURES.GSUITE_EMAIL_FIX
  ],
  [ROLES.SALES_AGENT]: [ROLE_FEATURES.CUSTOMER, ROLE_FEATURES.VIEW_OWN_AGENT_SALES, ROLE_FEATURES.ACCOUNT_LOGIN],
  [ROLES.SALES_MANAGER]: [ROLE_FEATURES.CUSTOMER, ROLE_FEATURES.VIEW_ALL_AGENT_SALES, ROLE_FEATURES.ACCOUNT_LOGIN],
  [ROLES.BETA]: [ROLE_FEATURES.ACCOUNT_RELINK],
  [ROLES.ESCALATED_SUPPORT]: [
    ROLE_FEATURES.CUSTOMER,
    ROLE_FEATURES.ACCOUNT_DETAILS,
    ROLE_FEATURES.COPY_SITE,
    ROLE_FEATURES.CANCEL_ACCOUNT,
    ROLE_FEATURES.ORDER_FOLLOWUPS,
    ROLE_FEATURES.ACCOUNT_LOGIN,
    ROLE_FEATURES.DOMAINS,
    ROLE_FEATURES.COMPLIANCE,
    ROLE_FEATURES.COMMENTS,
    ROLE_FEATURES.CONFIG_DEVELOPER_TOOLS,
    ROLE_FEATURES.SUSPICIOUS_MANAGEMENT,
    ROLE_FEATURES.VIEW_ACCOUNT_BUTTON,
    ROLE_FEATURES.ADD_EDIT_COUPONS,
    ROLE_FEATURES.REMOVE_FREE_DOMAIN_CREDIT,
    ROLE_FEATURES.GSUITE_EMAIL_FIX
  ],
  [ROLES.SUPPORT_MANAGER]: [
    ROLE_FEATURES.CUSTOMER,
    ROLE_FEATURES.ACCOUNT_DETAILS,
    ROLE_FEATURES.ACCOUNT_LOGIN,
    ROLE_FEATURES.COPY_SITE,
    ROLE_FEATURES.VIEW_ACCOUNT_BUTTON,
    ROLE_FEATURES.CANCEL_ACCOUNT,
    ROLE_FEATURES.ORDER_FOLLOWUPS,
    ROLE_FEATURES.DOMAINS,
    ROLE_FEATURES.COMPLIANCE,
    ROLE_FEATURES.ROLE_MANAGEMENT,
    ROLE_FEATURES.NEW_SP_ACCOUNT,
    ROLE_FEATURES.COMMENTS,
    ROLE_FEATURES.CONFIG_DEVELOPER_TOOLS,
    ROLE_FEATURES.SUSPICIOUS_MANAGEMENT,
    ROLE_FEATURES.ADD_EDIT_COUPONS,
    ROLE_FEATURES.REMOVE_FREE_DOMAIN_CREDIT,
    ROLE_FEATURES.GSUITE_EMAIL_FIX
  ]
}
